import m from "../../geodata/es2015/israelLow";
window.am4geodata_israelLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/israelLow.js
// module id = null
// module chunks = 